// extracted by mini-css-extract-plugin
export var author = "index-module--author--AcpJf";
export var companyNewsCard = "index-module--companyNewsCard--RrZ9u";
export var left = "index-module--left--Hl5oy";
export var right = "index-module--right--tsd7f";